import React, { useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { URL } from "../Redux/common/url";


function Cmimg({url,altkey}) {
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <div>
      <img
        src={url}
        alt={altkey}
        className={`blur-image ${isLoaded ? "hide" : ""}`}
        style={{
          filter: "blur(20px)",
          transition: "opacity 0.3s ease-in-out",
          opacity: isLoaded ? 0 : 1,
            width:"100%"
        }}
      />
      <LazyLoadImage
        alt={altkey}
        // width={imageWidth}
        // height={imageHeight}
        delayTime={300}
        onLoad={() => setIsLoaded(true)}
        style={{
          // Hide until loaded
          transition: "opacity 0.3s ease-in-out",
          opacity: isLoaded ? 1 : 0,
          width:"100%"
        }}
        src={url} // use normal <img> attributes as props
      />
    </div>
  );
}

export default Cmimg;
